
/**
 * 「区でさがす」主要リンク
 */
(function ($) {
  if($('.l-gNaviPC .parentLink').hasClass('is-acActive')){
    $('.js-childList').css('display','block');
  }
})(jQuery);


/**
 * チェックボックス
 */
(function($) {
    const $checkBox =  $('.checkBoxs input[type=checkbox]');
    $(() => {
        $checkBox.on('click', (e) => {
            if($(e.target).prop('checked')) {
                $(e.target).closest('li').addClass('is-checked');
            } else {
                $(e.target).closest('li').removeClass('is-checked');
            }
        });
    });
})(jQuery);


/**
 * フローティングメニュー
 */
$(window).scroll(() => {
  $('.js-floatingArea').each(function () {
    const menuTopMargin = 0;
    const parentY = $(this).parent().offset().top;
    const parentH = $(this).parent().height();
    const targetScrollValue = parentY - menuTopMargin;
    const wScrollvalue = $(window).scrollTop();
    let obj = {};
    if (wScrollvalue > targetScrollValue) {
      if (wScrollvalue > (parentY + parentH) - (menuTopMargin + $(this).height())) {
        obj = {
          position: 'absolute',
          top: parentH - $(this).height()
        };
      } else {
        obj = {
          position: 'fixed',
          top: menuTopMargin,
          left: -$(window).scrollLeft()
        };
      }
    } else {
      obj = {
        position: 'absolute',
        top: '0'
      };
    }
    $(this).css(obj);
  });
});


/**
 * SPメニュー
 */
(function ($) {
  const _touch = ('ontouchend' in document) ? 'touchend' : 'click';
  const $openBtn = $('.js-menuOpenBtn');
  const $menuBox = $('.js-mainMenuBox');
  const $closeBtn = $('.js-menuCloseBtn');
  $openBtn.on(_touch,function(event){
    event.preventDefault();
    event.stopPropagation();
    if($openBtn.hasClass('active')) {
      dropdown_close();
    } else {
      $(this).addClass('active');
      $menuBox.addClass('active').slideDown();
      $closeBtn.fadeIn();
    }
  });
  $closeBtn.on(_touch,(event) => {
    event.preventDefault();
    event.stopPropagation();
    if($openBtn.hasClass('active')) {
      dropdown_close();
    }
  });
  function dropdown_close() {
    $openBtn.removeClass('active');
    $menuBox.removeClass('active').slideUp();
    $closeBtn.fadeOut();
  }
})(jQuery);


/**
 * tel
 */
(function ($) {
  const ua = navigator.userAgent.toLowerCase();
  const isMobile = /iphone/.test(ua)||/android(.+)?mobile/.test(ua);
  if (!isMobile) {
      $('a[href^="tel:"]').on('click', (e) => {
          e.preventDefault();
      });
  }
})(jQuery);


/**
 * slider
 */
(function ($) {
  $(() => {
    $('.js-slide').slick({
      autoplay: true,
      dots: true,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            dots: false
          }
        }
      ]
    });
  });
})(jQuery);
